module.exports = __webpack_public_path__ + "static/media/chart-info-icon.b00de7dc.svg";